import { resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), {
    style: _normalizeStyle({
      height: _ctx.size,
      width: _ctx.size,
      fill: _ctx.color,
    })
  }, null, 8, ["style"]))
}